import { getRequest, postRequest } from "../utils/axios";

const projectQuery = (projectHash) => `?project=${projectHash}`;

export const environmentsService = {
  list: (projectHash, onSuccess, onError) =>
    getRequest(`/api/v1/environments/${projectQuery(projectHash)}`, onSuccess, onError),
  publish: (projectHash, hash, onSuccess, onError) =>
    postRequest(`/api/v1/environments/${hash}/publish/${projectQuery(projectHash)}`, {}, onSuccess, onError),
  rebuildPreview: (projectHash, hash, githubSha, onSuccess, onError) =>
    postRequest(
      `/api/v1/environments/${hash}/rebuild-preview/${projectQuery(projectHash)}`,
      { github_sha: githubSha },
      onSuccess,
      onError,
    ),
};
